import type { CloudCacheAccountRetentionCalloutProps } from "./CloudCacheAccountRetentionCallout";
import type { AddCloudCacheAccountCalloutProps } from "./AddCloudCacheAccountCallout";
import type { LightningProps } from "owa-lightning-core-v2";
import type { Component } from "react";
import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, LazyModule, type LazyComponent } from "owa-bundling";
export { getModuleUrl, getModuleUrlForNewAccount } from "./utils/getModuleUrl";
export { isEasiIdUser } from "./services/isEasiIdUser";
export { isEasiIdUserWithoutCloudCache } from "./services/isEasiIdUserWithoutCloudCache";
export { logUsageBasedOnPremiumFlag } from "./utils/logUsageBasedOnPremiumFlag";
export { isGreaterThanOrEqualTo } from "./utils/semverCompare";
export { isCloudCacheLoaded, userHadCloudCacheInSession, getStore } from "./store/store";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "CloudCache"*/ "./lazyIndex"), {
    name: "CloudCache",
});

// Export delay loaded components
export var CloudCacheOptionFull: LazyComponent<{}, unknown, void> = createLazyComponent(lazyModule, m => m.CloudCacheOptionFull);
export var AddCloudCacheAccountCallout: LazyComponent<AddCloudCacheAccountCalloutProps & LightningProps, Component<AddCloudCacheAccountCalloutProps & LightningProps, any, any>, void> = createLazyComponent(lazyModule, m => m.AddCloudCacheAccountCallout);
export var CloudCacheAccountRetentionCallout: LazyComponent<CloudCacheAccountRetentionCalloutProps & LightningProps, Component<CloudCacheAccountRetentionCalloutProps & LightningProps, any, any>, void> = createLazyComponent(lazyModule, m => m.CloudCacheAccountRetentionCallout);
export var AddCloudCacheAccountDialog: LazyComponent<{}, unknown, void> = createLazyComponent(lazyModule, m => m.AddCloudCacheAccountDialog);
